//#region types
import { TranslationKeys } from "translations";
import { CostForwardingSectionSubText, CostForwardingStatusLabel } from "./costForwardingMarkingModel";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

export function getCostForwardingLockedText(
  label: Exclude<CostForwardingStatusLabel, { key: "ReadyForForwarding" }>
): string {
  switch (label.key) {
    case "OnInvoiceDraft":
      return LocalizationHelperInstance.getFormattedMessage(TranslationKeys.CostForwarding.LockedOnInvoiceDraft, "", {
        invoiceSerialNumber: `${label.invoiceSerialNumber}`,
      });
    case "OnInvoiceDraftWithoutNumber":
      return LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.CostForwarding.LockedOnInvoiceDraftWithoutNumber
      );
    case "Forwarded":
      return LocalizationHelperInstance.getFormattedMessage(TranslationKeys.CostForwarding.LockedForwarded, "", {
        invoiceSerialNumber: `${label.invoiceSerialNumber}`,
      });
    case "ForwardedWithoutNumber":
      return LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.CostForwarding.LockedForwardedWithoutNumber
      );
  }
}

export function getCostForwardingSectionSubTextText(subText: CostForwardingSectionSubText): string {
  switch (subText.key) {
    case "Optional":
      return LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Optional);
    case "Customer":
      return subText.customerName;
  }
}
